export enum LayoutVariants {
  Colored = "colored",
  BlackAndWhite = "black-and-white",
}
